import { SET_SNACK_BAR, CLOSE_SNACK_BAR } from '../../utils/actionTypes';
const initial_state = {
  response_received: false,
  message: ""
};
export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case SET_SNACK_BAR:
      return (state = {
        ...state,
        response_received: true,
        message: action.payload.message,
        status: action.payload.status
      });
    case CLOSE_SNACK_BAR:
      return (state = { ...state, response_received: false, message: "", status: null });
    default:
      return state;
  }
}
